import { render, staticRenderFns } from "./Gotop.vue?vue&type=template&id=0ee2af1f"
import script from "./Gotop.vue?vue&type=script&lang=js"
export * from "./Gotop.vue?vue&type=script&lang=js"
import style0 from "./Gotop.vue?vue&type=style&index=0&id=0ee2af1f&prod&scrop=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports